const queryString = require('query-string');
export default class Request {
    constructor(baseUrl, token = null){
        this.baseUrl = baseUrl;
        this.token = token;
    }

    call(req){
        let options = {
			method: req.method,
			credentials: 'same-origin',
			headers: new Headers({
				'Content-Type': 'application/json',
				'Accept': 'application/json',
				'Authorization': `Bearer ${this.token}`
			})
		};
	
		if(req.body){
			options.body = JSON.stringify(req.body);
		}
	
		return new Promise((resolve, reject) => {
			const url = this.baseUrl+req.url;
			fetch(url, options)
				.then(response=>{
					if(response.ok){
						try{
							let clone = response.clone();
							return response.json()
							.then(json=>resolve({
								status: response.status,
								message: response.statusText,
								error: false,
								body: json
							}))
							.catch(e=>{
								return clone.text().then(text=>{
									resolve({
										status: response.status,
										message: response.statusText,
										error: false,
										body: text
									})
								})
							});
						}catch(error){
							throw response;
						}
					}
					throw response;
				})
				.catch(error=>{
					try{
						let clone = error.clone();
						return error.json()
						.then(json=>reject({
							status: error.status,
							message: error.statusText,
							error: true,
							body: json
						}))
						.catch(e=>{
							return clone.text().then(text=>{
								reject({
									status: error.status,
									message: error.statusText,
									error: true,
									body: text
								})
							})
						});
					}catch(e){
						return reject({
							status: 500,
							message: "An unknown error occurred",
							error: true,
							body: {
								message: "An unknown error occurred",
								errors: {
									"request": "An unknown error occurred"
								}
							}
						})
					}
				});
		})
    }
    
    get(url, params = false, token){
        if(params){
            const paramString = queryString.stringify(params);
            url += '?'+paramString;
        }

        return this.call({
            method: 'GET',
            url: url
        }, token);
    }

    post(url, body = {}){
        return this.call({
            method: 'POST',
            url, 
            body
        });
    }

    put(url, body = {}){
        return this.call({
            method: 'PUT',
            url, 
            body
        });
    }

    delete(url){
        return this.call({
            method: 'DELETE',
            url
        });
    }
};